import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionPointDisplay',
  props: {
    color: null,
    icon: null,
    value: null,
    rounded: {
      type: Boolean
    },
    horizontal: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const valueColorMap = generateColorMap({
      bg: 50,
      text: 600
    });
    const iconColorMap = generateColorMap({
      bg: 50,
      text: 500
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex grow rounded overflow-hidden cursor-pointer", {
          'flex-col': !__props.horizontal,
          'overflow-hidden rounded': __props.rounded
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["flex-1 p-1 flex-center", _unref(iconColorMap)[__props.color]])
      }, [_renderSlot(_ctx.$slots, "icon", {}, () => [_createVNode(_component_Icon, {
        icon: __props.icon,
        size: "1.25rem"
      }, null, 8, ["icon"])])], 2), _createElementVNode("div", {
        class: _normalizeClass(["flex-1 font-bold text-center px-1 flex-center whitespace-nowrap", _unref(valueColorMap)[__props.color]])
      }, [_renderSlot(_ctx.$slots, "value", {}, () => [_createTextVNode(_toDisplayString(Math.floor(__props.value)), 1)])], 2)], 2);
    };
  }
});